import {
  BookOpen, Radio, Bot, MonitorSmartphone, Hotel, Headset, ShoppingCart, Server, Code2,
  Library, Calculator, Handshake, PieChart, Megaphone, Contact, Expand, Apple, Presentation,
  PhoneCall, BriefcaseMedical, Compass, GraduationCap, Users, Truck, PlayCircle,
  Package, Network, Wrench,
} from "lucide-react";

/**
 * The Helpjuice export stores FontAwesome Pro classes ("far fa-hotel"). We
 * don't ship FontAwesome, so map the ones actually in use onto lucide and fall
 * back to a book for anything unmapped.
 */
const MAP = {
  "far fa-users": Users,
  "far fa-shipping-fast": Truck,
  "far fa-truck": Truck,
  "far fa-play-circle": PlayCircle,
  "far fa-broadcast-tower": Radio,
  "fab fa-windows": MonitorSmartphone,
  "far fa-hotel": Hotel,
  "far fa-headset": Headset,
  "far fa-shopping-cart": ShoppingCart,
  "far fa-server": Server,
  "far fa-code": Code2,
  "far fa-books": Library,
  "far fa-abacus": Calculator,
  "far fa-handshake-alt": Handshake,
  "far fa-handshake": Handshake,
  "far fa-chart-pie": PieChart,
  "far fa-bullhorn": Megaphone,
  "far fa-address-book": Contact,
  "far fa-expand-arrows-alt": Expand,
  "far fa-apple-crate": Apple,
  "far fa-chalkboard-teacher": Presentation,
  "far fa-atlas": BookOpen,
  "far fa-phone-office": PhoneCall,
  "far fa-blanket": Package,
  "far fa-medkit": BriefcaseMedical,
  "far fa-drafting-compass": Compass,
  "far fa-graduation-cap": GraduationCap,
};

// Name-based fallbacks so the icon-less categories from the export still get
// something meaningful rather than 20 identical books.
const BY_NAME = [
  [/video|connect premium/i, PlayCircle],
  [/analog|carrier/i, Radio],
  [/voice assist|\bai\b/i, Bot],
  [/teams|microsoft/i, MonitorSmartphone],
  [/hospitality|hotel/i, Hotel],
  [/operator|service desk/i, Headset],
  [/endpoint|device|phone/i, PhoneCall],
  [/network|sip|trunk/i, Network],
  [/troubleshoot|repair/i, Wrench],
  [/it\b|internal it|sysops|devops/i, Server],
  [/partner/i, Handshake],
  [/train|onboard/i, GraduationCap],
];

export function KbIcon({ icon, name = "", className = "h-6 w-6" }) {
  let Cmp = MAP[(icon || "").trim()];
  if (!Cmp) Cmp = (BY_NAME.find(([re]) => re.test(name)) || [null, BookOpen])[1];
  return <Cmp className={className} strokeWidth={1.6} />;
}
